import { 
    Button, 
    Checkbox, 
    FormControlLabel 
} from "@mui/material";
import React from "react";

interface IAudienceFooterProps {
    containerClassName: string;
    buttonClassName: string;
    checkBoxId: string;
    selectAllChecked: boolean;
    setSelectAll: (checked: boolean) => void;
    clearAll: () => void;
}

const AudienceFooter: React.FC<IAudienceFooterProps> = ({
    containerClassName,
    buttonClassName,
    checkBoxId,
    selectAllChecked,
    setSelectAll,
    clearAll
}) => {
    return (
        <div className={containerClassName}>
            {
                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={selectAllChecked} 
                            size="small" 
                            onChange={(_, checked) => setSelectAll(checked)}
                            id={checkBoxId}
                        />
                    }
                    label="Send to all employees"
                />
            }
            <Button
                className={buttonClassName}
                variant="text"
                color="primary"
                onClick={clearAll}
            >
                Clear all
            </Button>
        </div>
    );
}

export default AudienceFooter;